import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { Link, Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { AntennaBars5, ArrowsLeftRight, Check, Edit, GripVertical, MessageCircle, Photo, Plus, Search, Settings, Subtask, Trash } from 'tabler-icons-react';

import { EditComponent , NewComponent, EditComponentGroup} from './../Components';  
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { componentStatus } from '../../Constants/Constants';
import { Button, Drawer, Main, PageHeader, Skeleton } from '../../Components';
import { useList } from 'react-use';
import Tooltip  from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';


import './components.css'
import { useConfirmationModal } from '../../Hooks/useNotifications';
import toast from 'react-hot-toast';
import { Helmet } from 'react-helmet';
import { SetupComponentAutomation } from '../Automations/SetupComponentAutomation';
import { randomIntInterval } from '../../Helpers';
import { useSelector } from 'react-redux';
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import {TbEdit , TbSettingsAutomation} from 'react-icons/tb'
import {FiTrash2} from 'react-icons/fi'


export function Components() {

	const effectCalled = useRef(false)
	const { page_id } = useParams();
	const navigate = useNavigate()
	const [activeTab, setActiveTab] = useState(1);
	const { getConfirmation } = useConfirmationModal();
    const { height, width } = useWindowDimensions();

    //console.log('width : ' , width);

	const { user , org} = useSelector((state) => state.auth)
	

	if(!page_id){
		navigate('/pages')
	}

	const [isLoading, setIsLoading] = useState(true)
	const [components, setComponents] = useList([])
	const [activePage, setActivePage] = useState(0);
	const [listPerPage, setListPerPage] = useState(-1);
	const [totalRecords, setTotalRecords] = useState(0);
	const [openedRemovingComponent, setOpenedRemovingComponent] = useState(false);
	const [updatedComponent, setUpdatedComponent] = useState(0)
	const [openMonitoringAutomation, setOpenMonitoringAutomation] = useState({
		isOpen : false ,
		component : null 
	})


	useEffect( () => {
		if(effectCalled.current){ return ;}
		 
		async function fetchData() {

            // ! CHECK THE ACCESS 
            if(org?.statuspages?.findIndex(x => x.id === page_id) < 0 ) {
                navigate(`/pages`)
                return
            }

			const response = await getComponents({
				page : activePage / listPerPage,
				per_page : listPerPage
			})
		}
		fetchData();

		effectCalled.current = true ;
		
	}, [])

	useEffect(() => {
		// if(effectCalled.current){ return ;}
		if(updatedComponent > 0 ) updateComponentPosition()
		// effectCalled.current = true ;
	  
	}, [updatedComponent])
	



	const getComponents = async ({ page , per_page}) => {

		return new Promise(async(resolve, reject) => { 

			setIsLoading(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = {
					page : page ,
					per_page : per_page,
					 
				}

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/components` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					// Total records 
					setTotalRecords(data.total);

					setComponents.set(data.data)

					setIsLoading(false)
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setComponents.set([])
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. Thank you try later.`)
						}
					}
				})
			}else{
				setIsLoading(false)
			}

		})
	}


	/* const MenuOptions = ({ dataId }) => {
		return (
			<Menu delay={0}>
				<Menu.Item icon={<Settings size={14} />} onClick={() => navigate(`/pages/${page_id}/components/${dataId}/edit`)}>Edit</Menu.Item>
				<Menu.Item color="red" icon={<Trash size={14} />} onClick={() => openDeleteComponentModal({ component_id : dataId })}>Delete</Menu.Item>
			</Menu>
		)
	} */

	// const [selection, setSelection] = useState(['1']);

	/* const toggleRow = (id) =>
	  setSelection((current) =>
		current.includes(id) ? current.filter((item) => item !== id) : [...current, id]
	  );

	const toggleAll = () =>
	  setSelection((current) => (current.length === components.length ? [] : components.map((item) => item.id))); */

	 

	 

	const renderRows = (list , level =0  ) => {
		return (
			<Droppable droppableId={`dnd-${list.id}`} type={list.id} key={list.id} direction="vertical">
				 {(
					dropProvided,
					dropSnapshot
					// provided
				) => (
					<div 
						ref={dropProvided.innerRef}
						className={`${list?.is_group === true ? 'componentslist--group' : ''}`}
					>
						{
							list.id !=='root' && 
							<>
							<div className={`dragHandle`} {...dropProvided.droppableProps} >
								<GripVertical size={18} />
							</div>
							<div className={`dragContent`}>
								<div className='title'>{list?.name}</div>
								<div className='details'></div>
								<div className={`dragActionBtns`}>
									<Link 
										color="purple"
										className='btn btn-link btn-purple mr-10'
										to={`/pages/${page_id}/components/${list?.id}/group/edit`}
										
										>{
                                            width <= 450
                                            ? <TbEdit className='action-icon'/>
                                            : 'Edit'
                                        }</Link>
									<Button 
										color="red"
										link={true}
										onClick={() => openDeleteComponentGroupModal({ component_id : list?.id })} 
										>{
                                            width <= 450
                                            ? <FiTrash2 className='action-icon'/>
                                            : 'Delete'
                                        }</Button>
								</div>
							</div>
							</>
						}
						<div className="children">
							{
								list?.children?.map( ( item , index) => {
									return (
										item.is_group === false 
										? <Draggable key={item.id} draggableId={item.id} index={index}>
											{(provided, snapshot) => (
												<div
													
													// isDragging={snapshot.isDragging}
													// provided={provided}
													className={`componentslist--item ${snapshot.isDragging ? 'itemDragging' : ''}`}
													ref={provided.innerRef}
													{...provided.draggableProps}
												>
													<div {...provided.dragHandleProps} className={`dragHandle`}>
														<GripVertical size={18} />
													</div>
													<div className={`dragContent`}>
														<div className="status">{componentStatus.find( x => x.value === item?.status)?.icon}</div>
														<div className='title'>{item?.name}</div>
														<div className='details'>
															
															<Tooltip 
																placement="top" 
																trigger={['hover']} 
																overlay={<span>{
																	item?.display_chart=== true ? 'The uptime of this component is displayed on your status page' : 'The uptime of this component is not displayed on your status page'
																}</span>}
																>
																<AntennaBars5  color={item?.display_chart=== true ? '#333' : '#ccc'}/>
															</Tooltip>
															<div className='short-description'>{
																	item?.description?.length > 70 
																	? item?.description.substr(0 , 75)+'...' 
																	: item?.description
																	}</div>
														</div>
													</div>
													<div className={`dragActionBtns`}>
														<Button 
																color="gray"
																className='mr-10'
																link={true}
																onClick={() => setOpenMonitoringAutomation({ isOpen : true , component : item })} 
																>{
                                                                    width <= 450
                                                                    ? <TbSettingsAutomation className='action-icon'/>
                                                                    : 'Automation'}</Button>
														<Link 
															color="purple"
															className='btn btn-link btn-purple mr-10'
															to={`/pages/${page_id}/components/${item?.id}/edit`}
															
															>{
                                                                width <= 450
                                                                ? <TbEdit className='action-icon'/>
                                                                : 'Edit'
                                                            }</Link>
														<Button 
															color="red"
															link={true}
															onClick={() => openDeleteComponentModal({ component_id : item?.id })} 
															>{
                                                                width <= 450
                                                                ? <FiTrash2 className='action-icon'/>
                                                                : 'Delete'
                                                            }</Button>
													</div>
												</div>
											)}
										</Draggable>
										: (
											<Draggable draggableId={item.id} key={item.id} index={index}>
											{(
												dragProvided,
												dragSnapshot,
											) => (
											<div
												ref={dragProvided.innerRef}
												{...dragProvided.draggableProps}
												{...dragProvided.dragHandleProps}
												
											>
												{
													renderRows( {
														id : item.id ,
														name : item.name ,
														is_group : item?.is_group ,
														children : components.filter( x => item?.component_children?.includes(x.id)) 
													}  , level + 1)
												}
											</div>
											)}
										</Draggable>
										)
									)
								})
							}

						</div>
						{dropProvided.placeholder}
					</div>
				)}
			</Droppable>
		)
	}

	const openDeleteComponentModal = (params) => {

		 
		 
		getConfirmation({
			size : 'small',
			type: 'danger',
			title: "Deleting components",
			message: "Are you sure you want to delete your component? ",
			labels: { confirm: 'Delete component', cancel: "No don't delete it" },
			onConfirm : () => {
				deleteComponent(params?.component_id)
			},
			onCancel : () => {
				 

			}
		});
		
	}

	/**
	 * 
	 */	
	const deleteComponent = (COMPONENT_ID) => {

		return new Promise( async (resolve, reject) => { 
			
			// setIsLoading(true)
			 

			
			
			
			
			
			if (user && user.token && org && org?.id ) {
				 

				const token = user?.token;


				await axios.delete(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/components/${COMPONENT_ID}`, {
					params : {},
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {


					let _components = [...components];
					// _components = _components.filter((p) => p.id !== COMPONENT_ID);
					const index = _components.findIndex((p) => p.id === COMPONENT_ID);

					setComponents.removeAt(index) //(_components);

					// Update the Total records 
					let _totalRecords = totalRecords
					setTotalRecords(--_totalRecords);
					// setIsLoading(false)
					toast.success('Your component has been successfully deleted') 
					


					// components list 
					resolve(data.data)  
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					// setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
					 
				})
			}else{
				// setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})
	}

	const openDeleteComponentGroupModal = (params) => {

		getConfirmation({
			size : 'small',
			type: 'danger',
			title: "Deleting groups",
			message: <>
				<p>Are you sure you want to delete your component group? Please note that the deletion process cannot be undone.</p>
				<p>Please choose the action you want to apply to the child components from the following options.</p>
			</>,
			labels: { confirm: 'Delete component group', cancel: "No don't delete it" },
			options : { // radio button
				data : [
					{ id : 'delete-all-child-components' , name : 'Delete all child components of the group' },
					{ id : 'ungroup-all-child-components-to-root' , name : "Ungroup all of the child components, they won't be deleted." },
				],
				parameters : { 
					multichoise : false 	
				}
			},
			
			onConfirm : (response) => {
				//console.log(response)
				if(response && response?.length > 0 ) deleteComponentGroup(params?.component_id , response[0])
			},
			onCancel : () => {
				 

			}
		});


	}

	/**
	 * 
	 * @param {*} COMPONENT_ID (GROUP)
	 * @param {*} action ( delete-all-child-components / ungroup-all-child-components-to-root)
	 * @returns 
	 */
	const deleteComponentGroup = (COMPONENT_ID , action) => {

  		return new Promise( async (resolve, reject) => { 
			
			// setIsLoading(true)
			 

			
			
			
			
			
			if (user && user.token && org && org?.id ) {
				 

				const token = user?.token;


				await axios.delete(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/componentgroups/${COMPONENT_ID}`, {
					data : {
						action : action 
					},
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {


					let _components = [...components];
					if(action === 'delete-all-child-components'){
						// ! remove the group component 
						const index = _components.findIndex((p) => p.id === COMPONENT_ID);
						_components.splice(index, 1)  
						// ! remove al child components of the group 
						_components = _components?.filter(x => !(x.group_id === COMPONENT_ID || x.id === COMPONENT_ID))
						setComponents.set(_components)

							
					}else if (action === 'ungroup-all-child-components-to-root'){
						
						// ! remove the group component 
						const index = _components.findIndex((p) => p.id === COMPONENT_ID);
						_components.splice(index, 1)
						// ! ungroup the child component 
						_components = _components?.map( item => item.group_id === COMPONENT_ID ? ({ ...item , group_id : null }) : item)
						setComponents.set(_components)
					}
					// setIsLoading(false)
					toast.success('Your component group has been successfully deleted') 
					


					// components list 
					resolve(data.data)  
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					// setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
					 
				})
			}else{
				// setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})
	}

	/**
	 * 
	 */
	const closeComponentForm = () => {
		navigate(`/pages/${page_id}/components`)
	}

	/**
	 * { oldPosition , newPosition }
	 * @returns 
	 */
	const updateComponentPosition = () => {
		return new Promise( async (resolve, reject) => { 
			
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { 
					components : [...components]
				}

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/componentpositions`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					

					// toast.success('Awesome! Component order has been updated.') 
						 
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
					
				})
			}else{
				
				toast.error('Something went wrong, please try again later.')  
			}


		})
	}


	 

	let headerActionButtons = []
	if(components?.length > 0 ) headerActionButtons.push({
		name : "Add component",
		link : `/pages/${page_id}/components/new`
	} )

	/** 
	 * REORDER A LIST FROM TO GIVEN POSITION .
	 *  */
	const reorder = ({ items , from , to }) => {
		let cloned = [...items];
		const item = items[from];
	  
		cloned.splice(from, 1);
		cloned.splice(to, 0, item);
		 
		cloned = cloned.map( (item , index) =>  ({
				...item,
				position : index +1 
			})
		)

		cloned.sort((a,b) => a.position - b.position )
		 
		
		return cloned;
	}

	const SkeletonLoader_itemList = () => {
		return(
			[...Array(6)].map( (item, index) => {
				return( 
					<div key={index} className={`componentslist--item `} >
						<div className={`dragHandle`}>
							<Skeleton width={20} height={20} radius="sm" />
						</div>
						<div className={`dragContent`}>
							<div className="status"><Skeleton width={20} height={20} radius="sm" /></div>
							<div className='title'><Skeleton width={`${randomIntInterval(20 , 60)}%`} height={16} radius="sm" /></div>
						</div>
						<div className={`dragActionBtns`}>
							<Skeleton className='mr-10' width={30} height={20} radius="sm" />
							<Skeleton className='mr-10' width={30} height={20} radius="sm" />
							<Skeleton width={30} height={20} radius="sm" />
						</div>
					</div>
				)   
			})
		)  
	}

	/**
	 * 
	 */
	const getActivePage = () => {
		
		// Find the current status page from organization in Redux 
		const index = org?.statuspages?.findIndex( x => x.id === page_id)
		if(index >=0 ){
			return org?.statuspages[index]
		}   
		
		return false
	} 

    let breadcrumbsItems = []
    if(width > 450 ) breadcrumbsItems.push({ name: 'Home', link: '/' })
    breadcrumbsItems.push({ name: 'Status Pages', link: '/pages' })
    breadcrumbsItems.push({ name: getActivePage()?.name ?? 'Untitle Page' , link: `/pages/${page_id}` })
    if(width > 450 ) breadcrumbsItems.push({ name: 'Components', link: '' })


	return (
		<>
		<Helmet>
            <title>{`Components - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={breadcrumbsItems}
			 >
				<PageHeader
					title="Components"
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
					actionBtns={[
						{
							name : 'Add component' , link : `/pages/${page_id}/components/new`, color : 'purple'
						}
					]}
					/>
			 
				{
					isLoading === true 
					? <SkeletonLoader_itemList/> //'loading'//<SkeletonDraggableList rows={4}/>
					: (
						components?.length <=0
						? <div className={`components--no_items`} >
							<div className="comps_no_items--title">No components to display</div>
							<div className="comps_no_items--subtitle">The components of your website or application are the parts that allow it to function correctly. You can add some components here to view them.</div>
							<Button 
								component={Link} 
								to={`/pages/${page_id}/components/new`}
								leftIcon={<Plus size={20} strokeWidth={2}/>}
								>Add component</Button>
							</div>
						: <DragDropContext
							onDragEnd={  ({ destination, source }) =>{
								//console.log(components , destination , source );
								if(source !==null && destination !==null ){
									const parentGroup = destination?.droppableId === 'dnd-root' 
										? null 
										: destination?.droppableId?.substr(4)
									let reorderedList = reorder({ 
										items : components.filter( x => x.group_id === parentGroup ) , 
										from : source.index , 
										to : destination.index
									});
									let final_reorderedList = [...reorderedList, ...components.filter(x => !reorderedList.map(y => y.id).includes(x.id))]
									setComponents.set(final_reorderedList)
									// const res =  setComponents.sort({ from: source.index, to: destination.index });
									setUpdatedComponent(updatedComponent + 1 );

								}
							}
							}
							>
							{
								renderRows({
									id : 'root',
									name : null ,
									is_group : false ,
									children : components.filter( x => x.group_id === null )
								})
							}
						</DragDropContext> 
					)
					
					
				}
				
			{
				openMonitoringAutomation?.isOpen === true && 
				<Drawer
					title="Component automation"
					closeModal={() => setOpenMonitoringAutomation({
						isOpen : false ,
						component : null 
					})}
					isDisplay={true}
					hasFixedFooter={false}
					
					>
					<SetupComponentAutomation component={openMonitoringAutomation?.component} page_id={page_id}/>
					
				</Drawer>	 
			}	
			
			 	
			
			<Routes>
				<Route 
					path={`/new`} 
					element={<Drawer
						title="Add component"
						closeModal={closeComponentForm}
						isDisplay={true}
						
						>
						  <NewComponent onSuccess={ (response) => {

                            let _components = [...components]

                            // ? add/update the component_children of the selected group
							if(response?.group_id){
								const selectedGroupIndex = _components.findIndex( x => x.id === response?.group_id)   
                                if(selectedGroupIndex >=0 ){

                                    if(_components[selectedGroupIndex]?.component_children?.indexOf(response?.id) < 0) 
                                        _components[selectedGroupIndex]?.component_children.push(response?.id)
                                }else{// create a new group 
                                    _components.push({
										id : response?.group?.id ,
										name : response?.group?.name,
										is_group : true ,
										component_children : [ response?.id ],
										group_id:null,
										description : null ,
										position : 0,
										statuspage_id : response?.statuspage_id
									})
                                }
							} 

                            //console.log(_components);

							// setComponents.push(response)
							// setComponents.insertAt(0 , response)
                            _components.push(response)
                            // Update the component 
							setComponents.set(_components)
						}}/> 
					</Drawer>} />
				<Route 
					path={`/:component_id/edit`} 
					element={<Drawer
						title="Edit component"
						closeModal={closeComponentForm}
						isDisplay={true}
						>
						<EditComponent onSuccess={ (response) => {

							let _components = [...components]

							const index = _components?.findIndex((p) => p.id === response?.id )
							
							// ? add/update the component_children of the selected group
							if(response?.group_id){
								const selectedGroupIndex = _components.findIndex( x => x.id === response?.group_id)   
								if(selectedGroupIndex >=0 ){ // group already existe in the component list 

									if(_components[selectedGroupIndex]?.component_children?.indexOf(response?.id) < 0) 
										_components[selectedGroupIndex]?.component_children.push(response?.id)
								}else{ // create a new one 
									_components.push({
										id : response?.group?.id ,
										name : response?.group?.name,
										is_group : true ,
										component_children : [ response?.id ],
										group_id:null,
										description : null ,
										position : 0,
										statuspage_id : response?.statuspage_id
									})
								}
							} 
							// ! remove the component_id from component_children of all groups
							const oldGroupIndex = _components.findIndex(x => x.is_group === true && x.id !== response?.group_id && x.component_children.includes(response?.id))
							if(_components[oldGroupIndex]?.component_children?.indexOf(response?.id) >= 0) 
								_components[oldGroupIndex].component_children = _components[oldGroupIndex].component_children.filter(y => y !== response?.id)

							_components[index] = response 	 
							// Update the component 
							setComponents.set(_components)

							 
						}}/>
					</Drawer>} />
				<Route 
					path={`/:component_id/group/edit`} 
					element={<Drawer
						title="Edit component group"
						closeModal={closeComponentForm}
						isDisplay={true}
						>
						<EditComponentGroup onSuccess={ (response) => {
							 
							const index = components?.findIndex((p) => p.id === response?.id )
							
							// Update the component 
							setComponents.updateAt(index , response)
							 
						}}/>
					</Drawer>} />
			</Routes> 
			 
			 </Main>
		</>
	)
}
